import { combineReducers } from 'redux';

import transactions from './create';
import dialogs from './dialogs';

const reducer = combineReducers({
  [transactions.name]: transactions.reducer,
  [dialogs.name]: dialogs.reducer,
});

export default reducer;
